import { Icon } from "@opendash/icons";
import { Button, Space, Table, Tag, Tooltip } from "antd";
import { ColumnType } from "antd/es/table";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { SIV_GoodsReceiptProcess } from "../../../parsegenerated";

type Props = {
  goodsReceipts: SIV_GoodsReceiptProcess[];
  loading?: boolean;
  onViewPositions?: (receipt: SIV_GoodsReceiptProcess) => void;
};

export const GoodsReceiptProcessTable = observer((props: Props) => {
  const { goodsReceipts, loading, onViewPositions } = props;

  const columns: ColumnType<SIV_GoodsReceiptProcess>[] = [
    {
      title: "Nr.",
      dataIndex: "no",
      key: "no",
      sorter: (a, b) => a.no.localeCompare(b.no),
    },
    {
      title: "Datum",
      dataIndex: "date",
      key: "date",
      render: (date: Date) => (date ? dayjs(date).format("DD.MM.YYYY") : "-"),
      sorter: (a, b) => {
        if (!a.date || !b.date) return 0;
        return dayjs(a.date).valueOf() - dayjs(b.date).valueOf();
      },
    },
    {
      title: "Lagerort",
      dataIndex: "storageLocation",
      key: "storageLocation",
      render: (val: string) =>
        val ? (
          <Tag color="blue">
            <Icon icon="fa:warehouse" /> {val}
          </Tag>
        ) : (
          "-"
        ),
    },
    {
      title: "Gewicht",
      dataIndex: "weight",
      key: "weight",
      render: (val: number) => (val ? `${val} kg` : "-"),
    },
    {
      title: "Kommentar",
      dataIndex: "comment",
      key: "comment",
      ellipsis: true,
      render: (val: string) => val || "-",
    },
    {
      title: "Lieferschein",
      key: "deliveryNote",
      render: (_, record) =>
        record.deliveryNote ? (
          <Tag color="green">{record.deliveryNote.no}</Tag>
        ) : (
          "-"
        ),
    },
    {
      title: "Aktionen",
      key: "actions",
      width: 120,
      render: (_, record) => (
        <Space.Compact>
          {onViewPositions && (
            <Tooltip title="Positionen anzeigen">
              <Button
                size="small"
                icon={<Icon icon="fa:list" />}
                onClick={() => onViewPositions(record)}
              />
            </Tooltip>
          )}
        </Space.Compact>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={goodsReceipts}
      loading={loading}
      rowKey={(record) => record.id!}
      size="small"
      pagination={{ pageSize: 10 }}
    />
  );
});
